<div class="page">
    <app-header title="{{ 'landingPage.patients'| translate }}"> </app-header>
    <ngx-loading [show]="showSpinner"></ngx-loading>

    <div class="page-content">
        <div class="table-top">
            <div class="section-header">{{ "landingPage.patients" | translate }}</div>
        </div>
        <div class="table-body">
            <table class="table table-striped table-bordered">
                <thead>
                    <tr class="table-names">
                        <th>{{ "usersModule.firstAndLastName" | translate }}</th>
                        <th>{{ "usersModule.email" | translate }}</th>
                        <th>{{ "usersModule.role" | translate }}</th>
                        <th>{{ "status" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let userInvite of users; let i = index"
                        [ngClass]="userInvite.isCurrentUser ? 'inactiveTableRow table-row' : 'table-row'">
                        <th>{{ userInvite.fullName }}</th>
                        <th>{{ userInvite.email }}</th>
                        <th class="text-center">
                            {{ translate.instant(userInvite.role) }}
                        </th>
                        <th class="text-center">
                            {{ translate.instant(userInvite.currentStatus) }}
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
        <app-pagination 
        [options]="options" 
        [pagedList]="usersGrid.apiEnabledInvites"
        [callback]="loadData"
        ></app-pagination>
    </div>
</div>